import React from "react";
import {observer} from "mobx-react";
import useAuth from "../hooks/use-auth";
import {useRouter} from "@morningtrain/react-navigation";
import {useOnOperationExecute} from "@morningtrain/react-resources";

function OnLoginReaction() {

    const auth = useAuth();
    const router = useRouter();

    useOnOperationExecute(() => {

        auth.refresh()
            .then(() => {
                if (router.hasRedirectOnLoginRoute) {
                    router.navigate(router.redirectOnLoginRoute)
                }
            });

    });
    return null;
}

export default observer(OnLoginReaction);
